import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';
import { PostLoginRedirectService, AuthenticationService, ErrorHandlerService, AuthenticatedUser } from '@aveva/connect-web-core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  private readonly translate = inject(TranslateService);
  private readonly postLoginRedirect = inject(PostLoginRedirectService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);
  private readonly errorHandler = inject(ErrorHandlerService);
  constructor() {
    this.translate.setDefaultLang('en');
    this.postLoginRedirect.watch();
    this.authenticationService.registerCallbackHandler(
      (user) => this.onAuthenticationCallbackSuccess(user),
      (error) => this.onAuthenticationCallbackError(error)
    );
  }

  private async onAuthenticationCallbackSuccess(
    user: AuthenticatedUser
  ): Promise<void> {
    if (user.account) {
      this.router.navigate(['/erm'], { replaceUrl: true });
    } else {
      try {
        await this.errorHandler.handle(
          'callback.controller: Could not retrieve the user.account property',
          'accountDetailsNotAvailable'
        );
      } catch {}
      await this.authenticationService.signout();
    }
  }

  private async onAuthenticationCallbackError(error: Error): Promise<void> {
    try {
      await this.errorHandler.handle(error, 'signin_failed');
    } catch {}
    await this.authenticationService.signout();
  }
}
